import type { ComponentType, ReactNode } from "react";
import { Icon, type IconName } from "./icons";
import s from "./tabbar.module.css";

/** "99+" above 99; nothing at 0. */
export const badgeText = (n: number): string | null => (n <= 0 ? null : n > 99 ? "99+" : String(n));

export function TabBar({ label, children }: { label: string; children: ReactNode }) {
  return <nav className={s.tabs} aria-label={label}>{children}</nav>;
}

export interface TabBarItemProps {
  label: string;
  icon: IconName;
  active?: boolean;
  badge?: number;
  /** A router `Link` (receives `to`) or `"a"`. */
  as?: ComponentType<{ to: string; className?: string; "aria-current"?: "page"; "aria-label"?: string; children?: ReactNode }> | "a";
  to: string;
}

export function TabBarItem({ label, icon, active, badge, as, to }: TabBarItemProps) {
  const text = badge === undefined ? null : badgeText(badge);
  const common = { className: s.item, "aria-current": active ? ("page" as const) : undefined, "aria-label": text ? `${label}, ${badge} unread` : label };
  const body = <><Icon name={icon} />{label}{text ? <span className={s.badge} aria-hidden="true">{text}</span> : null}</>;
  if (!as || as === "a") return <a href={to} {...common}>{body}</a>;
  const Link = as;
  return <Link to={to} {...common}>{body}</Link>;
}

/** The centred 58px action button; rotates 45° while its sheet is open. */
export function TabBarFab({ open, onClick, label }: { open: boolean; onClick: () => void; label: string }) {
  return (
    <div className={s.fabw}>
      <button type="button" className={s.fab} aria-label={label} aria-haspopup="dialog" aria-expanded={open} onClick={onClick}><Icon name="plus" size={26} strokeWidth={2.2} /></button>
    </div>
  );
}
